(function ($) {



    $(document).on('ready', function () {

        // const $body = $('body');
        //
        // const isCategoryPage = $body.hasClass('category');
        // const isSearchPage = $body.hasClass('search');
        //
        // if (isCategoryPage || isSearchPage) {
        //
        //     const $postsGrid = $('.posts-grid__wrap');
        //
        //     if ($postsGrid.length === 0)
        //         return;
        //
        //     const targetPosition = $postsGrid.offset().top - document.documentElement.clientHeight * 0.3;
        //
        //     $('html, body').stop().animate(
        //         {
        //             scrollTop: targetPosition,
        //         },
        //         500
        //     )
        //
        // }

    });


})(jQuery);